import "@brainhubeu/react-carousel/lib/style.css";
import React from "react";
import "./App.css";
import SketchContainer from "./Splash/SketchContainer";
import LogRocket from "logrocket";
import { SizingProvider }  from './Splash/Context/SizingContext';
class App extends React.Component {
  componentDidMount() {
    LogRocket.init("convdy/splash");
    if (process.env.NODE_ENV !== "development") {
      const body = document.querySelector("body");
      body?.setAttribute("oncontextmenu", "return false;");
    }
  }

  render() {
    return (
      <SizingProvider>
      <div className="App">
        <div
          className={`loadingScreen setFullHeight`}
          style={{
            position: "absolute",
            background: "white",
            width: "100vw",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "absolute",
              color: "white",
              fontSize: "80px",
              fontFamily: "'amatic', cursive",
              top: "40%",
              right: "50%",
              left: "35%",
              bottom: "50%",
              width: "fit-content",
            }}
          >
            <img
              style={{ width: "30vw" }}
              src={require("./Assets/artThreadLogo.png")}
            />
          </div>
        </div>
        <SketchContainer />
      </div>
      </SizingProvider>
    );
  }
}

export default App;
